import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';


import 'swiper/css';

import 'swiper/css/navigation';

import 'swiper/css/pagination';

import 'swiper/css/effect-fade';

$(function () {
	$('.bloc-slider-swiper').each(function () {
		const $slider = $(this);
		const $block = $slider.closest('.bloc-slider');

		const swiper = new Swiper(this, {
			modules: [ Pagination, Autoplay, EffectFade],
			slidesPerView: 1,
			loop: true,
			speed: 900,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			/*
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			*/
			pagination: {
				el: $slider.find('.swiper-pagination')[0],
				clickable: true
			},
			
			on: {
				init: function () {
					activateSlideAnimations(this);
				},
				slideChangeTransitionStart: function () {
					resetSlideAnimations(this);
				},
				slideChangeTransitionEnd: function () {
					activateSlideAnimations(this);
				}
			}
		});

		function resetSlideAnimations(swiperInstance) {
			$(swiperInstance.slides).find('.js-slider-anim').removeClass('is-visible');
		}

		function activateSlideAnimations(swiperInstance) {
			const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);

			$activeSlide.find('.js-slider-anim').each(function (index) {
				const $el = $(this);

				setTimeout(function () {
					$el.addClass('is-visible');
				}, 150 + (index * 180));
			});
		}
	});
});